import React from "react";
import { Dialog } from "@mui/material";
import Icon from "./Icon";
import { answerKeyItems, pluralize, passMark } from "./testsModel";

function Question({ item }) {
  return (
    <li className="q">
      <div><h4>{item.text}</h4></div>
      {item.options.length > 0 && (
        <ul>
          {item.options.map((o) => (
            <li key={o.letter} className={o.correct ? "ok" : ""}>
              <i>{o.letter}</i>
              {o.text}
              {o.correct && <><Icon n="check" s={13} /><span className="sr">Correct answer</span></>}
            </li>
          ))}
        </ul>
      )}
      {item.pairs.length > 0 && (
        <ul>
          {item.pairs.map((p, i) => <li key={i} className="ok"><i>{i + 1}</i>{p.prompt} → <b>{p.answer}</b></li>)}
        </ul>
      )}
      {item.isShort && (
        <ul>
          {item.accepted.length > 0
            ? item.accepted.map((a, i) => <li key={i} className="ok"><i>✓</i>{a}</li>)
            : <li><i>–</i>No accepted answers set</li>}
        </ul>
      )}
    </li>
  );
}

/** Instructor-only answer key for a test: every question with the correct answers marked. */
export default function AnswerKeyDialog({ test, onClose }) {
  const items = test ? answerKeyItems(test) : [];
  const total = test?.questionCount ?? items.length;
  return (
    <Dialog open={Boolean(test)} onClose={onClose} maxWidth="md" fullWidth aria-labelledby="answer-key-title"
      PaperProps={{ sx: { borderRadius: "16px" } }}>
      <div className="tl-root tl-key">
        <div className="akh">
          <span className="tile" aria-hidden="true"><Icon n="key" s={17} /></span>
          <div>
            <h2 id="answer-key-title">Answer key · {test?.title}</h2>
            <p>
              {pluralize(total, "question")}
              {passMark(test) ? ` · ${passMark(test)}` : ""}
              {test?.timeLimitMinutes ? ` · ${test.timeLimitMinutes} min` : " · No time limit"}
            </p>
          </div>
          <button type="button" className="ib" onClick={onClose} aria-label="Close"><Icon n="x" s={18} /></button>
        </div>
        <div className="akn"><Icon n="lock" s={14} />For instructors only. Do not share with students.</div>
        <div className="akb">
          {items.length === 0 ? <p className="note">This test has no questions yet.</p> : <ol>{items.map((it) => <Question key={it.id} item={it} />)}</ol>}
        </div>
        <div className="akf">
          <span>Showing {items.length} of {total} questions</span>
          <button type="button" className="btn btn-o btn-sm" onClick={() => window.print()}><Icon n="print" />Print</button>
          <button type="button" className="btn btn-p btn-sm" onClick={onClose}>Close</button>
        </div>
      </div>
    </Dialog>
  );
}
